
import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const HEADER_OFFSET = 140;

export function useSmoothScroll() {
  const { hash } = useLocation();

  useEffect(() => {
    if (!hash) return;

    const targetId = hash.replace('#', '');
    const scrollToElement = () => {
      const element = document.getElementById(targetId);
      if (element) {
        const elementPosition = element.getBoundingClientRect().top + window.scrollY;
        window.scrollTo({
          top: elementPosition - HEADER_OFFSET,
          behavior: 'smooth',
        });
      }
    };

    // 少し遅延させてDOMの準備を待つ
    const timer = setTimeout(scrollToElement, 100);
    return () => clearTimeout(timer);
  }, [hash]);

  useEffect(() => {
    const handleAnchorClick = (e: MouseEvent) => {
      const target = e.target as HTMLElement;
      const anchor = target.closest('a[href^="#"]') as HTMLAnchorElement | null;
      if (!anchor) return;

      const href = anchor.getAttribute('href');
      if (!href || !href.startsWith('#')) return;

      const targetId = href.replace('#', '');
      const element = document.getElementById(targetId);
      if (element) {
        e.preventDefault();
        const elementPosition = element.getBoundingClientRect().top + window.scrollY;
        window.scrollTo({
          top: elementPosition - HEADER_OFFSET,
          behavior: 'smooth',
        });
        // URLのハッシュを更新
        window.history.pushState(null, '', href);
      }
    };

    document.addEventListener('click', handleAnchorClick);
    return () => document.removeEventListener('click', handleAnchorClick);
  }, []);
}
